import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import BottomNav from '../../../components/layout/BottomNav';
import BackButton from '../../../components/common/BackButton';

const G = '#166534';

export default function LandMessagesPage() {
  const navigate = useNavigate();
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/land/inquiries');
        setThreads(data.inquiries || data.data || []);
      } catch { setThreads([]); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div style={{ background:'#F5F7FA', minHeight:'100vh', fontFamily:'Inter,system-ui,sans-serif', paddingBottom:90 }}>
      <div style={{ background:G, padding:'14px 16px 14px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <BackButton />
        <div style={{ fontSize:17, fontWeight:700, color:'white' }}>Messages</div>
        <div style={{ width:34 }} />
      </div>

      <div style={{ padding:'14px 14px 0' }}>
        {loading ? (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {[1,2].map(i => <div key={i} style={{ height:70, background:'white', borderRadius:14, opacity:.5 }} />)}
          </div>
        ) : threads.length === 0 ? (
          <div style={{ textAlign:'center', padding:'60px 0', color:'#9CA3AF' }}>
            <div style={{ fontSize:44, marginBottom:10 }}>💬</div>
            <div style={{ fontSize:14 }}>No messages yet</div>
            <div style={{ fontSize:12, marginTop:4 }}>Inquiries from interested buyers will show up here</div>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {threads.map(t => (
              <div key={t._id} style={{ background:'white', borderRadius:14, border:'0.5px solid #E5E7EB', padding:'12px 14px' }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a' }}>{t.fromName || 'Interested buyer'}</div>
                <div style={{ fontSize:12, color:'#6B7280', marginTop:3 }}>{t.message}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}